/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Division_SalesInputs */

const en_mk_mock_division_sales = /** @type {(inputs: Mk_Mock_Division_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales & CS`)
};

const id_mk_mock_division_sales = /** @type {(inputs: Mk_Mock_Division_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales & CS`)
};

/**
* | output |
* | --- |
* | "Sales & CS" |
*
* @param {Mk_Mock_Division_SalesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_division_sales = /** @type {((inputs?: Mk_Mock_Division_SalesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Division_SalesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_division_sales(inputs)
	return en_mk_mock_division_sales(inputs)
});